// extracted by mini-css-extract-plugin
export default {"NavItems":"Menu_NavItems__QnuN2","logo":"Menu_logo__oRZCl","ContactButton":"Menu_ContactButton__X-4ig","NotScrolled":"Menu_NotScrolled__XPYaG","nav":"Menu_nav__xowF0"};